import { render } from "./TripDocumentsPanel.vue?vue&type=template&id=cf7e2d8c&scoped=true"
import script from "./TripDocumentsPanel.vue?vue&type=script&lang=js"
export * from "./TripDocumentsPanel.vue?vue&type=script&lang=js"

import "./TripDocumentsPanel.vue?vue&type=style&index=0&id=cf7e2d8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf7e2d8c"]])

export default __exports__